module.exports = __webpack_public_path__ + "img/PT.36abdd0c.png";